import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/about/page.tsx");
